<template>

    <div class="mb-5 product-teasers">
        <div class="" v-if="!loaded">
            <div class="spinner-grow" role="status">
                <span class="visually-hidden">{{ __('Lade...') }}</span>
            </div>
        </div>
        <div v-else-if="loaded && products.length === 0">
            {{ __('Keine Produkte gefunden') }}
        </div>
        <div class="product-list" v-else>
            <div class="col" v-for="product in products">
                <product :product="product" />
            </div>
        </div>
    </div>

</template>


<script>
    import Product from '@/shared/Product';

    export default {
        props: {
            products: {
                type: Array
            },
            loaded: {
                default: true,
                type: Boolean
            }},
        components: {
            Product,
        },
        data() {
            return {
            }
        }
    }
</script>